import AuthRoute, { IFormContainerProps } from './AuthRoute';
import CreatePassword from './CreatePassword';
import Field from '@rezdy/components/Form/Field';
import React from 'react';
import TextInput from '@rezdy/components/Form/FormElements/TextInput';
import queryString from '../services/queryString';
import routing from '../services/routing';
import { withTranslation } from 'react-i18next';

export class ResetPassword extends AuthRoute {
    constructor(props: IFormContainerProps) {
        super(props);
        this.state.message = 'checkEmail';
    }

    renderBody = () => {
        const params = queryString.parse(routing.location.search);
        const username = decodeURIComponent((params.username as string) || '');
        const { i18n } = this.props;
        return (
            <React.Fragment>
                <Field label={i18n.t('resetCode')} name="code">
                    <TextInput type="text" autoComplete="code" />
                </Field>
                <CreatePassword name="newPassword" />
                <input type="hidden" name="username" defaultValue={username} />
            </React.Fragment>
        );
    };
}

export default withTranslation()(ResetPassword);
